/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Delivered_PlaceholderInputs */

const vi_order_carrier_delivered_placeholder = /** @type {(inputs: Order_Carrier_Delivered_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: AWB VTP123456, giao 14:30 ngày 15/07`)
};

/**

* @param {Order_Carrier_Delivered_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_delivered_placeholder = /** @type {((inputs?: Order_Carrier_Delivered_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Delivered_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_delivered_placeholder(inputs)
});